import { UPLOAD_TYPES } from 'constants.js'
import {
    VALIDATE_RULE,
    MAX_PKG_SIZE,
    MAX_URL_CSV_SIZE,
    MAX_UPLOAD_FILE_COUNT,
    supprotPKGFileExts,
    supportURLFileExts,
} from '../constants'

export const genTitle = (dialogType, step) => {
    switch (dialogType) {
        case 'singleReplace': {
            return '更新操作'
        }
        case 'multiUpload': {
            return step === 1 ? '批量上传' : '操作结果'
        }
        case 'multiReplace': {
            return step === 1 ? '批量替换' : '操作结果'
        }
        default: {
            return '上传'
        }
    }
}

export const getWarningMsg = (dialogType, existLength, notExistLength) => {
    if (dialogType === 'multiUpload') {
        return `您一共选择了${existLength + notExistLength}个渠道号的包，成功${notExistLength}个${
            existLength > 0 ? `, 有${existLength}个渠道包名称重复不能上传。` : ''
        }`
    } else {
        return `您一共选择了${existLength + notExistLength}个渠道包，成功匹配${existLength}个${
            notExistLength > 0 ? `, 失败${notExistLength}个。` : ''
        }`
    }
}

export const getItemByName = (channelName, pkgList = []) => {
    let res = null
    pkgList.forEach(item => {
        if (item.channelName === channelName) {
            res = item
            return
        }
    })
    return res
}

// 单个字段校验规则
export const validateField = (field = '', value, required) => {
    let isValid = true,
        error = ''

    if (field === 'files' || field === 'urlFile') {
        if (!value || value.length === 0) {
            error = `请选择要上传的${VALIDATE_RULE[field].label}文件`
            isValid = false
        } else if (value.length > MAX_UPLOAD_FILE_COUNT) {
            error = '渠道包数量不能超过100个'
            isValid = false
        } else {
            let files = value
            const fileNames = []
            let max_size = MAX_PKG_SIZE
            let file_exts = supprotPKGFileExts

            if (field === 'urlFile') {
                max_size = MAX_URL_CSV_SIZE
                file_exts = supportURLFileExts
            }
            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                const file_ext = file.name.split('.').pop()
                // 仅支持apk，3G以内
                if (file.size > max_size) {
                    error = `${VALIDATE_RULE[field].label}文件<${file.name}>大小错误，应小于${Math.ceil(
                        max_size / (1024 * 1024)
                    )}M`
                    isValid = false

                    break
                } else if (!file_exts.includes(file_ext)) {
                    error = `${VALIDATE_RULE[field].label}文件"${
                        file.name
                    }"格式错误(${file_ext}) ，仅支持${file_exts.join(',')}`
                    isValid = false
                    break
                } else if (fileNames.includes(file.name)) {
                    error = '文件名称重复'
                    isValid = false
                    break
                } else if (field === 'files' && !isMatchSuffix(file.name)) {
                    // 提前检测apk后缀只能检测 本地apk文件上传的方式。excel 批量上传下载地址的方式不支持，需要在 nodejs 端实现
                    error = `${VALIDATE_RULE[field].label}文件"${file.name}"名称错误 ，结尾必须为 -32.apk 或 -64.apk 或 -32-64.apk，指明包体位数。`
                    isValid = false
                    break
                } else {
                    fileNames.push(file.name)
                    error = ''
                }
            }
        }
    } else {
        if (required && !value) {
            error = `请输入${VALIDATE_RULE[field].label}`
            isValid = false
        } else if (!VALIDATE_RULE[field].regx.test(value)) {
            error = `${VALIDATE_RULE[field].label}长度或格式错误`
            isValid = false
        }
    }
    return { isValid, error }
}

// 校验文件名是否以正确的后缀结尾
export const isMatchSuffix = fileName => {
    if (fileName.endsWith('-32.apk') || fileName.endsWith('-64.apk') || fileName.endsWith('-32-64.apk')) {
        return true
    }
    return false
}

// 去掉文件名（渠道名）后面的 包体位数后缀和 .apk 后缀
export const removeSuffix = fileName => {
    const removeApk = fileName.replace(/.apk$/, '')
    if (removeApk.endsWith('-32-64')) {
        return removeApk.substring(0, removeApk.length - 6)
    }

    if (removeApk.endsWith('-32') || removeApk.endsWith('-64')) {
        return removeApk.substring(0, removeApk.length - 3)
    }

    return removeApk
}

// 去掉 .apk 后缀
export const removeApk = fileName => {
    return fileName.replace(/.apk$/, '')
}

export const validateSettingForm = (dialogType, uploadType, formData) => {
    let isValid = true,
        fieldsToCheck = [],
        newFormError = {}

    if (dialogType === 'singleReplace') {
        fieldsToCheck.push('channelName')
    }

    if (uploadType === UPLOAD_TYPES.INPUT_LINK) {
        // 填写下载链接
        fieldsToCheck.push('url')
    } else if (uploadType === UPLOAD_TYPES.LOCAL_UPLOAD) {
        // 本地上传渠道包
        fieldsToCheck.push('files')
    } else if (uploadType === UPLOAD_TYPES.UPLOAD_LINK_CSV) {
        // 上传渠道包url文件
        fieldsToCheck.push('urlFile')
    }
    fieldsToCheck.forEach(field => {
        const { isValid: isFieldValid, error } = validateField(field, formData[field], true)
        if (!isFieldValid) {
            isValid = false
        }
        newFormError[field] = error
    })

    return {
        isValid,
        formError: newFormError,
    }
}

export const isSingle = dialogType => {
    return dialogType === 'singleReplace'
}
